import { createThirdwebClient } from 'thirdweb';
import { ethereum } from 'thirdweb/chains';
import { inAppWallet, createWallet } from 'thirdweb/wallets';

export const thirdwebClient = createThirdwebClient({
  clientId: 'ef76c96ae163aba05ebd7e20d94b81fd',
});

export const targetChain = ethereum;

// Supported wallets shown in the connect modal
export const supportedWallets = [
  createWallet('io.metamask'),
  createWallet('com.coinbase.wallet'),
  createWallet('walletConnect'),
  inAppWallet({
    auth: { options: ['email', 'google'] },
  }),
];
